export default __webpack_public_path__ + "static/media/suomalainen.0d35ba9e.png";